<template>
    <div>
        <b-button
            @click="addMetadata"
            v-if="!params.assignedPropertiesFilter"
            variant="default"
        >
            <font-awesome-icon :icon="['fas', 'plus']"></font-awesome-icon>
        </b-button>
        <b-button @click="deleteMetadata" v-else variant="default"
            ><font-awesome-icon :icon="['fas', 'trash']"></font-awesome-icon
        ></b-button>
    </div>
</template>

<script>
export default {
    methods: {
        addMetadata() {
            this.params.assignAmenity &&
                this.params.assignAmenity(this.params.data.id);
        },
        deleteMetadata() {
            this.params.removeAmenity &&
                this.params.removeAmenity(this.params.data.id);
        },
    },
};
</script>

<style></style>
